function removeClass(element: HTMLElement, data: string): void {
    element.classList.remove(...data.split(' ').filter(Boolean));
}

export default removeClass;
